import { createAction, props } from '@ngrx/store';
import { IRevenuecatCustomer } from 'app/models/revenuecat-customer';

export const clearAllItems = createAction('[DalHelper] Clear All RevenueCat Customers');

export const loadItemFromUser = createAction('[Module Component] Load RevenueCat Customer from User');
export const loadItem = createAction('[Module Component] Load RevenueCat Customer', props<{ id: string }>());
export const loadItemSuccess = createAction('[RevenueCat API] Load Load RevenueCat Customer Success', props<{ item: IRevenuecatCustomer }>());
export const loadItemFailure = createAction('[RevenueCat API] Load Load RevenueCat Customer Failure', props<{ error: any }>());

export const upsertItem = createAction('[RevenueCat API] Load RevenueCat Customer', props<{ item: IRevenuecatCustomer }>());


